import { render, staticRenderFns } from "./App.vue?vue&type=template&id=cfd5979a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=cfd5979a&prod&scoped=true&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=cfd5979a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd5979a",
  null
  
)

export default component.exports